const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingTop: '8px',
    [theme.breakpoints.down('sm')]: {
      gap: '12px',
      paddingTop: '6px',
    },
    [theme.breakpoints.down('xs')]: {
      gap: '8px',
      paddingTop: '4px',
    },
  },
  title: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#282F35',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
  },
})

export default styles
